import React, { Component } from 'react';
export default class PrerequisiteSubWrapper extends Component {
  render() {
  return(
    <div className="prerequisite">
     
    </div>
    );
  }
}
